<div class="task-movements">

  <!-- header -->
  <div class="row">
    <div class="col-12">
      <h3 class="text-manax m-0 mb-4">
        <span class="pull-right">
          <button mat-icon-button type="button" (click)="dialog.close()">
            <i class="material-icons">close</i>
          </button>
        </span>
        <span class="text-purple-manax text-capitalize title-modal">
          Fichajes
          <span *ngIf="isByWorker"><span style="text-transform: lowercase !important;">de</span>
            {{worker.firstname || ''}} {{worker.lastname || ''}}</span>
          <span *ngIf="isByClient"><span style="text-transform: lowercase !important;">en</span>
            {{client.corporatename ? client.corporatename : (client.firstname || '') + ' ' + (client.lastname ||
            '')}}</span>
          <span *ngIf="isByTask"><span style="text-transform: lowercase !important;">en</span>
            {{task.title || ''}} {{task.category?.[0]?.name || ''}}</span>
        </span>
      </h3>
    </div>
  </div>

  <!-- body -->
  <div class="row" *ngIf="loading">
    <div class="col-12 mb-4">
      <div class="d-flex justify-content-center">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="!loading">
    <div class="col-md-2" *ngIf="isByWorker">
      <mat-form-field appearance="outline">
        <input matInput [(ngModel)]="searchClient" placeholder="Buscar por Cliente" type="text"
          (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()">
      </mat-form-field>
    </div>
    <div class="col-md-2" *ngIf="isByWorker || isByClient">
      <mat-form-field appearance="outline">
        <input matInput [(ngModel)]="searchTask" placeholder="Buscar por Trabajo" type="text"
          (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()">
      </mat-form-field>
    </div>
    <div class="col-md-2" *ngIf="isByWorker || isByClient">
      <mat-form-field appearance="outline">
        <input matInput [(ngModel)]="searchCategory" placeholder="Buscar por Categoría" type="text"
          (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()">
      </mat-form-field>
    </div>
    <div class="col-md-2" *ngIf="isByClient || isByTask">
      <mat-form-field appearance="outline">
        <input matInput [(ngModel)]="searchWorker" placeholder="Buscar por Trabajador" type="text"
          (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()">
      </mat-form-field>
    </div>
    <div class="col-md-2">
      <mat-form-field appearance="outline">
        <mat-label>
          Período
        </mat-label>
        <mat-select [(ngModel)]="monthOffset" (ngModelChange)="periodChange()">
          <mat-option [value]="0">Mes Actual</mat-option>
          <mat-option [value]="1">Mes Pasado</mat-option>
          <mat-option [value]="9">Histórico</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-md-3" *ngIf="isByTask">
      &nbsp;
    </div>
    <div class="col-md-3">
      <button mat-raised-button type="button" class="pull-right btn btn-outline-success" (click)="exportListByWorker()"
        *ngIf="isByWorker"> <i class="material-icons">download</i> Descargar </button>
      <button mat-raised-button type="button" class="pull-right btn btn-outline-success" (click)="exportListByClient()"
        *ngIf="isByClient"> <i class="material-icons">download</i> Descargar </button>
      <button mat-raised-button type="button" class="pull-right btn btn-outline-success" (click)="exportListByTask()"
        *ngIf="isByTask"> <i class="material-icons">download</i> Descargar </button>
    </div>

    <div class="col-12 task-movements-content">
      <div class="row">
        <div class="col-md-1" *ngIf="isByWorker"><b>Cliente</b></div>
        <div class="col-md-1" *ngIf="isByWorker || isByClient"><b>Trabajo</b></div>
        <div class="col-md-1" *ngIf="isByWorker || isByClient"><b>Categoría</b></div>
        <div class="col-md-1" *ngIf="isByTask || isByClient"><b>Trabajador</b></div>
        <div class="col-md-2"><b>Fecha</b></div>
        <div class="col-md-2"><b>Entrada</b></div>
        <div class="col-md-2"><b>Salida</b></div>
        <div class="col-md-1"><b>Tiempo agendado</b></div>
        <div class="col-md-1"><b>Tiempo trabajado</b></div>
        <div class="col-md-1"><b>Tiempo de descanso</b></div>
      </div>
      <div class="row" *ngFor="let mov of movements">
        <div class="col-md-1 text-manax cursor-pointer" *ngIf="isByWorker" (click)="openClientModal(mov.client)">
          {{mov.client?.firstname}} {{mov.client?.lastname}}
        </div>
        <div class="col-md-1 text-manax cursor-pointer" *ngIf="isByWorker || isByClient"
          (click)="openTaskModal(mov.task)">
          {{mov.task?.title}}
        </div>
        <div class="col-md-1 text-manax cursor-pointer" *ngIf="isByWorker || isByClient"
          (click)="openTaskModal(mov.task)">
          {{mov.category?.name}}
        </div>
        <div class="col-md-1 text-manax cursor-pointer" *ngIf="isByTask || isByClient"
          (click)="openWorkerModal(mov.worker)">
          {{mov.worker?.firstname}} {{mov.worker?.lastname}}
        </div>
        <div class="col-md-2 small">{{mov.task.scheduledStart | date:'dd/MM/yyyy HH:mm:ss'}}</div>
        <div class="col-md-2 small">{{mov.in | date:'dd/MM/yyyy HH:mm:ss'}}</div>
        <div class="col-md-2 small">{{mov.out | date:'dd/MM/yyyy HH:mm:ss'}}</div>
        <div class="col-md-1 small">{{convertMsToHM(mov.totalScheduled)}}</div>
        <div class="col-md-1 small">{{convertMsToHM(mov.totalrealworked)}}</div>
        <div class="col-md-1 small">{{convertMsToHM(mov.totalbreak)}}</div>
      </div>
    </div>
  </div>
</div>